import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServiceDenied2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 160,
	viewBox: "0 0 200 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1563_12532)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M24.3176 154.606L28.4753 154.605L30.4531 138.568L24.3167 138.569L24.3176 154.606Z",
					fill: "#FFB6B6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.1714 158.944L36.957 158.943V158.781C36.9568 156.033 34.7289 153.805 31.9805 153.805L29.6448 152.033L25.2873 153.805L24.1712 153.805L24.1714 158.944Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.7511 154.606L46.9089 154.605L48.8867 138.568L42.7503 138.569L42.7511 154.606Z",
					fill: "#FFB6B6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.605 158.944L55.3906 158.943V158.781C55.3904 156.033 53.1625 153.805 50.4141 153.805L48.0784 152.033L43.7209 153.805L42.6048 153.805L42.605 158.944Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.732 65.1074L20.7443 65.6124C20.7443 65.6124 16.4319 72.6825 19.7243 82.6563L19.3555 85.4339L20.8705 89.7264L21.628 102.857L20.8705 104.877L21.3755 108.664C21.3755 108.664 19.3555 133.662 24.4055 146.287L30.4656 146.034L32.7381 113.095L31.4756 110.684L31.7281 109.674L34.7581 94.5239L37.7882 102.352V106.701L40.5657 109.927C40.5657 109.927 39.5557 139.722 42.3332 145.782H49.1179L51.6758 105.382L49.1508 81.8988L49.6558 80.3838L48.8982 79.6263L49.4033 77.1013L44.732 65.1074Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.5069 19.0253L27.1843 17.2578L25.1643 22.0554C25.1643 22.0554 14.7131 27.6104 14.2081 35.1855C14.2081 35.1855 12.7917 41.2455 14.0542 44.0231C15.3167 46.8006 20.6193 55.6382 20.6193 55.6382C20.6193 55.6382 15.8217 71.0408 17.0842 71.7983C18.3468 72.5558 48.3945 71.0408 48.3945 69.5258C48.3945 68.0108 43.3938 52.1031 43.3938 52.1031L42.3345 24.8329L35.5169 22.3079L34.5069 19.0253Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.9843 81.1819C16.5169 80.4095 17.1333 78.5411 16.3611 77.0085C16.2833 76.8542 16.1918 76.7119 16.0934 76.5767L20.168 48.6406L14.5269 48.8211L11.576 76.0404C10.5065 76.9476 10.1519 78.4974 10.8109 79.8051C11.5831 81.3377 13.4516 81.9541 14.9843 81.1819Z",
					fill: "#FFB6B6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68.5101 67.9977C69.1271 66.3963 68.3292 64.5978 66.7278 63.9807C66.5666 63.9186 66.4032 63.8746 66.2395 63.8406L50.4989 40.4043L46.4402 44.3261L62.5321 66.4767C62.3488 67.8671 63.1267 69.2536 64.4932 69.7801C66.0946 70.3972 67.893 69.5992 68.5101 67.9977Z",
					fill: "#FFB6B6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2652 41.5939C26.8591 36.1183 24.2119 30.5317 18.509 30.5587C16.8607 30.5665 15.5801 31.0448 15.2252 32.3688C13.983 37.0027 13.3056 43.9977 13.3056 43.9977L11.832 51.4452L12.7246 52.9915L10.8638 57.9825L11.7664 60.3437L11.9615 72.4015L16.5066 72.149L21.5144 62.9568L23.4293 61.8182C23.4293 61.8182 21.8917 46.9558 24.9501 42.6766L25.2652 41.5939Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.621 28.1183C42.9633 23.0725 36.1594 21.8773 32.0762 25.8586C30.896 27.0094 30.3072 28.243 30.9717 29.4419C33.2975 33.638 38.6886 38.1559 38.6886 38.1559L45.3276 48.829L47.0439 49.3212L49.1728 54.2038L53.735 59.5676L59.7775 62.7542L63.3125 59.2192L62.5619 54.675L53.4649 42.554C53.4649 42.554 46.9195 34.3187 46.1465 29.116L45.621 28.1183Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.113 17.5486C32.9458 17.5687 32.7791 17.5838 32.6132 17.5914C32.0972 17.6197 31.5873 17.5903 31.096 17.507C29.6031 17.2677 28.2468 16.5606 27.2003 15.5236C26.0938 14.4295 25.3366 12.969 25.132 11.3065C24.6524 7.38202 27.447 3.80714 31.3714 3.32762C35.2395 2.8522 38.7655 5.55765 39.3284 9.392C39.3372 9.45135 39.3464 9.50821 39.3527 9.5673C39.832 13.4942 37.0402 17.0669 33.113 17.5486Z",
					fill: "#FFB6B6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.9447 9.12989C39.9281 9.63262 38.2671 8.05214 37.6309 8.96147C37.5276 8.76496 37.4134 8.57491 37.3007 8.39518C37.1986 8.23436 37.0527 7.89107 36.8838 7.83227C37.0975 8.34794 37.0503 9.04632 36.8286 9.64467C35.8257 10.0194 34.5131 9.18996 33.585 8.20893C32.1276 6.67067 29.7479 10.6152 30.3106 12.6566C29.5945 11.7822 28.0406 12.2754 27.514 13.2752C26.9877 14.2725 27.877 15.0716 28.0672 16.1841L26.6316 16.0018C25.7259 15.1196 25.7893 13.6332 25.0434 12.6108C23.7976 10.8997 23.3149 9.15391 24.2514 7.38804C25.0822 5.82665 25.1598 3.80588 26.6838 2.90569C26.0179 2.58012 28.386 3.08874 27.7535 2.02775C27.1181 0.96898 30.5045 0.840473 30.7254 1.4077C31.6931 0.249584 32.6691 -0.513985 33.8595 0.413997C35.0285 1.32698 34.9075 2.28664 36.2806 2.20064C36.9248 2.16072 36.8541 3.36195 37.2371 3.88567C37.6179 4.40659 39.098 4.741 39.1701 4.68525C39.561 4.37937 40.8911 6.98326 40.8911 6.98326C40.8911 6.98326 41.9696 8.62045 40.9447 9.12989Z",
					fill: "#2F2E41"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.543 54.5781C106.488 54.5781 86.9883 74.0781 86.9883 98.1326C86.9883 122.187 106.488 141.687 130.543 141.687C154.597 141.687 187.888 117.838 174.097 98.1326C160.307 78.4273 154.597 54.5781 130.543 54.5781Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M72.2449 56.6504C72.6355 56.6504 72.9531 56.968 72.9531 57.3586V80.0211C72.9531 80.4117 72.6355 80.7293 72.2449 80.7293C71.8543 80.7293 71.5367 80.4117 71.5367 80.0211V57.3586C71.5367 56.968 71.8543 56.6504 72.2449 56.6504Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M191.225 39.6523C191.616 39.6523 191.934 39.97 191.934 40.3605V46.0262C191.934 46.4167 191.616 46.7344 191.225 46.7344C190.835 46.7344 190.517 46.4167 190.517 46.0262V40.3605C190.517 39.97 190.835 39.6523 191.225 39.6523Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M191.225 56.6504C191.616 56.6504 191.934 56.968 191.934 57.3586V68.3357C191.934 68.7263 191.616 69.0439 191.225 69.0439C190.835 69.0439 190.517 68.7263 190.517 68.3357V57.3586C190.517 56.968 190.835 56.6504 191.225 56.6504Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M191.225 72.2305C191.616 72.2305 191.934 72.5481 191.934 72.9387V83.9158C191.934 84.3064 191.616 84.624 191.225 84.624C190.835 84.624 190.517 84.3064 190.517 83.9158V72.9387C190.517 72.5481 190.835 72.2305 191.225 72.2305Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M127.71 17.3438C128.1 17.3438 128.418 17.6614 128.418 18.052V29.0291C128.418 29.4197 128.1 29.7373 127.71 29.7373C127.319 29.7373 127.002 29.4197 127.002 29.0291V18.052C127.002 17.6614 127.319 17.3438 127.71 17.3438Z",
					fill: "#3F3D56"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.2119 153.187C18.4804 153.233 18.0761 152.324 18.6296 151.794L18.6846 151.575C18.6774 151.558 18.6701 151.54 18.6628 151.523C17.923 149.759 15.4157 149.771 14.6822 151.538C14.0311 153.106 13.2022 154.676 12.9981 156.334C12.9066 157.066 12.9478 157.812 13.1102 158.53C11.5847 155.197 10.7819 151.559 10.7819 147.899C10.7819 146.98 10.8323 146.061 10.9352 145.143C11.0198 144.393 11.1364 143.648 11.2874 142.909C12.1038 138.916 13.8718 135.112 16.4219 131.935C17.6478 131.265 18.6701 130.218 19.2876 128.962C19.5095 128.509 19.6833 128.022 19.7656 127.526C19.6261 127.544 19.2396 125.42 19.3448 125.289C19.1504 124.994 18.8024 124.848 18.59 124.56C17.534 123.128 16.0791 123.378 15.3195 125.324C13.6969 126.142 13.6812 127.501 14.6768 128.807C15.3102 129.638 15.3973 130.762 15.953 131.652C15.8958 131.725 15.8364 131.796 15.7792 131.869C14.7307 133.214 13.8238 134.659 13.0593 136.178C13.2754 134.49 12.9564 132.457 12.4126 131.146C11.7936 129.653 10.6333 128.395 9.6115 127.104C8.38418 125.554 5.86746 126.23 5.65122 128.196C5.64912 128.215 5.64709 128.234 5.64508 128.253C5.79685 128.339 5.94554 128.43 6.09078 128.526C6.91919 129.074 6.63289 130.358 5.65131 130.509L5.62909 130.513C5.68399 131.06 5.77776 131.602 5.91496 132.134C4.60415 137.204 7.43409 139.05 11.4749 139.133C11.5641 139.179 11.651 139.224 11.7402 139.268C11.3308 140.421 11.0037 141.603 10.7613 142.801C10.544 143.86 10.3931 144.931 10.3085 146.006C10.2032 147.362 10.2124 148.725 10.3268 150.079L10.3199 150.031C10.0294 148.54 9.21981 147.147 8.04424 146.182C6.29299 144.743 3.81882 144.213 1.92953 143.057C1.02007 142.5 -0.145309 143.22 0.0134168 144.274L0.0211325 144.325C0.302441 144.439 0.576879 144.572 0.842196 144.72C0.99396 144.806 1.14263 144.897 1.28789 144.993C2.1163 145.541 1.83 146.825 0.848421 146.977L0.826181 146.98C0.810165 146.982 0.796444 146.985 0.78047 146.987C1.26304 148.133 1.93543 149.196 2.77709 150.113C3.5967 154.539 7.11697 154.958 10.8825 153.67H10.8848C11.2965 155.463 11.898 157.215 12.671 158.884H19.052C19.0749 158.813 19.0955 158.74 19.1161 158.669C18.526 158.706 17.9313 158.672 17.3504 158.564C17.8239 157.983 18.2973 157.398 18.7707 156.817C18.7821 156.805 18.7913 156.794 18.8004 156.782C19.0406 156.485 19.283 156.19 19.5232 155.893L19.5233 155.892C19.5383 154.98 19.4287 154.07 19.2119 153.187Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M200 158.904C200 159.138 199.812 159.325 199.579 159.325H0.471052C0.237356 159.325 0.0496705 159.138 0.0496705 158.904C0.0496705 158.67 0.237356 158.482 0.471052 158.482H199.579C199.812 158.482 200 158.67 200 158.904Z",
					fill: "#CCCCCC"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M149.583 95.1958H174.094V94.4876H149.583C147.453 94.4876 145.721 92.7551 145.721 90.6256V74.0527H145.013V90.6256C145.013 93.1455 147.063 95.1958 149.583 95.1958Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M102.814 131.121H158.562V131.829H102.814V131.121Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.4455 90.461H97.2225C98.8294 90.461 100.137 89.1537 100.137 87.5467V58.133C100.137 56.5261 98.8294 55.2188 97.2225 55.2188H67.4455C65.8385 55.2188 64.5312 56.5261 64.5312 58.133V87.5467C64.5312 89.1537 65.8385 90.461 67.4455 90.461Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.6782 56.0879C95.8708 56.0879 99.2695 59.4867 99.2695 63.6793V86.9235C99.2695 88.3981 98.0741 89.5935 96.5995 89.5935H78.3917C71.2169 89.5935 65.4007 83.7772 65.4007 76.6025V58.7579C65.4007 57.2833 66.5961 56.0879 68.0707 56.0879L91.6782 56.0879Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.359 64.6354H90.3717C90.6772 64.6354 90.9258 64.3868 90.9258 64.0813C90.9258 63.7758 90.6772 63.5273 90.3717 63.5273H74.359C74.0536 63.5273 73.8051 63.7758 73.8051 64.0813C73.8051 64.3868 74.0536 64.6354 74.359 64.6354Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.359 76.4498H90.3717C90.6772 76.4498 90.9258 76.2012 90.9258 75.8958C90.9258 75.5903 90.6772 75.3418 90.3717 75.3418H74.359C74.0536 75.3418 73.8051 75.5903 73.8051 75.8958C73.8051 76.2012 74.0536 76.4498 74.359 76.4498Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.8581 70.5455H96.8756C97.1811 70.5455 97.4297 70.2969 97.4297 69.9915C97.4297 69.686 97.1811 69.4375 96.8756 69.4375H67.8581C67.5526 69.4375 67.3042 69.686 67.3042 69.9915C67.3042 70.2969 67.5526 70.5455 67.8581 70.5455Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.5609 81.2526H78.0436C78.3491 81.2526 78.5977 81.004 78.5977 80.6985C78.5977 80.393 78.3491 80.1445 78.0436 80.1445H67.5609C67.2554 80.1445 67.007 80.393 67.007 80.6985C67.007 81.004 67.2554 81.2526 67.5609 81.2526Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.99 149.067H153.635C154.911 149.067 155.949 148.029 155.949 146.753V123.396C155.949 122.12 154.911 121.082 153.635 121.082H129.99C128.714 121.082 127.676 122.12 127.676 123.396V146.753C127.676 148.029 128.714 149.067 129.99 149.067Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M149.23 121.771C152.559 121.771 155.258 124.47 155.258 127.8V146.257C155.258 147.428 154.309 148.377 153.138 148.377H138.679C132.982 148.377 128.364 143.759 128.364 138.061V123.892C128.364 122.721 129.313 121.771 130.484 121.771L149.23 121.771Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M135.478 128.56H148.193C148.435 128.56 148.633 128.362 148.633 128.12C148.633 127.877 148.435 127.68 148.193 127.68H135.478C135.235 127.68 135.038 127.877 135.038 128.12C135.038 128.362 135.235 128.56 135.478 128.56Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M135.478 137.94H148.193C148.435 137.94 148.633 137.743 148.633 137.5C148.633 137.258 148.435 137.061 148.193 137.061H135.478C135.235 137.061 135.038 137.258 135.038 137.5C135.038 137.743 135.235 137.94 135.478 137.94Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.315 133.253H153.357C153.599 133.253 153.797 133.055 153.797 132.813C153.797 132.57 153.599 132.373 153.357 132.373H130.315C130.072 132.373 129.875 132.57 129.875 132.813C129.875 133.055 130.072 133.253 130.315 133.253Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.08 141.755H138.404C138.646 141.755 138.844 141.557 138.844 141.315C138.844 141.072 138.646 140.875 138.404 140.875H130.08C129.837 140.875 129.64 141.072 129.64 141.315C129.64 141.557 129.837 141.755 130.08 141.755Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.517 73.8736H164.003C164.947 73.8736 165.715 73.1059 165.715 72.1623V54.8891C165.715 53.9454 164.947 53.1777 164.003 53.1777H146.517C145.573 53.1777 144.806 53.9454 144.806 54.8891V72.1623C144.806 73.1059 145.573 73.8736 146.517 73.8736Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M160.745 53.6875C163.207 53.6875 165.203 55.6834 165.203 58.1455V71.7957C165.203 72.6616 164.501 73.3636 163.635 73.3636H152.943C148.729 73.3636 145.314 69.948 145.314 65.7347V55.2555C145.314 54.3895 146.016 53.6875 146.882 53.6875L160.745 53.6875Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M150.576 58.7073H159.979C160.159 58.7073 160.305 58.5613 160.305 58.3819C160.305 58.2025 160.159 58.0566 159.979 58.0566H150.576C150.397 58.0566 150.251 58.2025 150.251 58.3819C150.251 58.5613 150.397 58.7073 150.576 58.7073Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M150.576 65.6448H159.979C160.159 65.6448 160.305 65.4988 160.305 65.3194C160.305 65.14 160.159 64.9941 159.979 64.9941H150.576C150.397 64.9941 150.251 65.14 150.251 65.3194C150.251 65.4988 150.397 65.6448 150.576 65.6448Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.759 62.178H163.8C163.979 62.178 164.125 62.032 164.125 61.8526C164.125 61.6732 163.979 61.5273 163.8 61.5273H146.759C146.58 61.5273 146.434 61.6732 146.434 61.8526C146.434 62.032 146.58 62.178 146.759 62.178Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.585 68.4651H152.741C152.92 68.4651 153.066 68.3192 153.066 68.1398C153.066 67.9604 152.92 67.8145 152.741 67.8145H146.585C146.406 67.8145 146.26 67.9604 146.26 68.1398C146.26 68.3192 146.406 68.4651 146.585 68.4651Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.4863 95.6543C93.5307 95.6543 91.9453 94.0689 91.9453 92.1133C91.9453 90.1576 93.5307 88.5723 95.4863 88.5723C97.442 88.5723 99.0273 90.1576 99.0273 92.1133C99.0273 94.0689 97.442 95.6543 95.4863 95.6543Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M145.412 77.5937C143.456 77.5937 141.871 76.0084 141.871 74.0527C141.871 72.0971 143.456 70.5117 145.412 70.5117C147.368 70.5117 148.953 72.0971 148.953 74.0527C148.953 76.0084 147.368 77.5937 145.412 77.5937Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M128.416 126.105C126.46 126.105 124.875 124.52 124.875 122.564C124.875 120.609 126.46 119.023 128.416 119.023C130.372 119.023 131.957 120.609 131.957 122.564C131.957 124.52 130.372 126.105 128.416 126.105Z",
					fill: "#0077C8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M120.766 27.9218C118.329 27.9218 116.353 25.9876 116.353 23.6015C116.353 21.2155 118.329 19.2812 120.766 19.2812C123.204 19.2812 125.18 21.2155 125.18 23.6015C125.18 25.9876 123.204 27.9218 120.766 27.9218Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M85.3882 22.124H109.143C109.958 22.124 110.621 21.4609 110.621 20.646C110.621 19.831 109.958 19.168 109.143 19.168H85.3882C84.5733 19.168 83.9103 19.831 83.9103 20.646C83.9103 21.4609 84.5733 22.124 85.3882 22.124Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.8499 27.1259H109.143C109.958 27.1259 110.621 26.4629 110.621 25.6479C110.621 24.833 109.958 24.1699 109.143 24.1699H66.8499C66.0349 24.1699 65.3719 24.833 65.3719 25.6479C65.3719 26.4629 66.0349 27.1259 66.8499 27.1259Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.648 46.0803C183.07 46.0803 181.792 44.8285 181.792 43.2843C181.792 41.7401 183.07 40.4883 184.648 40.4883C186.225 40.4883 187.504 41.7401 187.504 43.2843C187.504 44.8285 186.225 46.0803 184.648 46.0803Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M161.752 42.3271H177.125C177.653 42.3271 178.082 41.898 178.082 41.3706C178.082 40.8432 177.653 40.4141 177.125 40.4141H161.752C161.224 40.4141 160.795 40.8432 160.795 41.3706C160.795 41.898 161.224 42.3271 161.752 42.3271Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M149.754 45.5654H177.125C177.653 45.5654 178.082 45.1363 178.082 44.6089C178.082 44.0815 177.653 43.6523 177.125 43.6523H149.754C149.227 43.6523 148.797 44.0815 148.797 44.6089C148.797 45.1363 149.227 45.5654 149.754 45.5654Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M98.9524 145.582C97.375 145.582 96.0962 144.33 96.0962 142.786C96.0962 141.242 97.375 139.99 98.9524 139.99C100.53 139.99 101.809 141.242 101.809 142.786C101.809 144.33 100.53 145.582 98.9524 145.582Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76.0564 141.829H91.4302C91.9576 141.829 92.3867 141.4 92.3867 140.873C92.3867 140.345 91.9576 139.916 91.4302 139.916H76.0564C75.529 139.916 75.0999 140.345 75.0999 140.873C75.0999 141.4 75.529 141.829 76.0564 141.829Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.0586 145.067H91.4302C91.9576 145.067 92.3867 144.638 92.3867 144.111C92.3867 143.583 91.9576 143.154 91.4302 143.154H64.0586C63.5312 143.154 63.1021 143.583 63.1021 144.111C63.1021 144.638 63.5312 145.067 64.0586 145.067Z",
					fill: "#F2F2F2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.284 55.2285H133.992V88.8681H133.284V55.2285Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.641 90.9934C132.468 90.9934 131.516 90.0421 131.516 88.8688C131.516 87.6954 132.468 86.7441 133.641 86.7441C134.814 86.7441 135.766 87.6954 135.766 88.8688C135.766 90.0421 134.814 90.9934 133.641 90.9934Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.418 115.427C100.245 115.427 99.2938 114.476 99.2938 113.302C99.2938 112.129 100.245 111.178 101.418 111.178C102.592 111.178 103.543 112.129 103.543 113.302C103.543 114.476 102.592 115.427 101.418 115.427Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M158.782 86.3898C157.608 86.3898 156.657 85.4386 156.657 84.2652C156.657 83.0918 157.608 82.1406 158.782 82.1406C159.955 82.1406 160.906 83.0918 160.906 84.2652C160.906 85.4386 159.955 86.3898 158.782 86.3898Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.565 84.2693L171.184 84.6211L171.162 85.3293L159.543 84.9775L159.565 84.2693Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84.1314 121.436H101.75V113.303H101.042V120.728H84.1314V121.436Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.653 109.589C158.479 109.589 157.528 108.638 157.528 107.464C157.528 106.291 158.479 105.34 159.653 105.34C160.826 105.34 161.777 106.291 161.777 107.464C161.777 108.638 160.826 109.589 159.653 109.589Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.577 115.598H160.195V107.465H159.487V114.89H142.577V115.598Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M88.669 99.3809H173.293V100.089H88.669V99.3809Z",
					fill: "#E6E6E6"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1563_12532",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 200,
				height: 159.325,
				fill: "white",
				transform: "matrix(-1 0 0 1 200 0)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgServiceDenied2);
export default ForwardRef;
